import React, { useEffect, useRef, useState } from "react";
import DashboardFilter from "../../containers/dashboardFilter";
import {
  formatTileName,
  checkPayoutCsv,
  partnerIdentityForPayouts,
  getPartnerRoleID,
  timeStampFormat,
  downloadArrayAsCSV,
  downloadPayoutCsvExportContent,
  getPayoutSchemeRestrictionPartnerRole,
  isRestrictedPayoutSchemeAllRole,
  PAYOUT_ALL_SCHEME_NOT_ALLOWED_MESSAGE,
} from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerFetchPayoutQuantity,
  triggerFetchPayoutHeaderCSV,
  triggerFetchPayoutItemCSV,
  triggerFetchTimeStamp,
  showError,
  hideError,
  triggerDashboardAudit,
} from "../../redux/actions";
import { resetPayoutDashboardState } from "../../redux/actions/payoutAction";
import {
  fetchShowAlertPayout,
  hideAlertPayout,
  triggerDownloadFile,
  triggerFetchPayoutHeader,
} from "../../redux/actions/payoutAction";
import { ExportToCsv } from "export-to-csv";
import Spinner from "../presentationals/Spinner";
import { CustomCardPayout } from "../customCardPayout/index";
import {
  triggerShowHeader,
  setPayoutDashboard,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { payoutLineItemCsvFilter } from "../../utils/common/csvMappings/payoutCsv";
// import { NO_DATA_AVAILABLE } from "../../constants/index";
import Error from "../Error/index";
import Alert from "../alert/index";
import axios from "axios";
import DownloadModal from "../downloadModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import alert from "../alert/index";
import { CircularProgress } from "@material-ui/core";

const PayoutDashboard = (props) => {
  const {
    quantityObj,
    headerCsvLoading,
    lineItemCsvLoading,
    headerObj,
    // headerCSVObj,
    // itemCSVObj,
    showAlert,
  } = useSelector((state) => state.payoutReducer);
  const {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    filterSchemeType,
    isBusinessType,
    timestamp,
    error,
    shouldRun,
    selectedOptionData,
    partnerRoleType,
    // filterList
  } = useSelector((state) => state.homeReducer);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState(null);

  const shouldBlockRestrictedAllDownload = (fv = filterValue) => {
    if (props.component !== "activation" && props.component !== "recharge") {
      return false;
    }
    const role = getPayoutSchemeRestrictionPartnerRole(
      fv,
      selectedOptionData,
      isBusinessType,
      partnerRoleType
    );
    if (!isRestrictedPayoutSchemeAllRole(role)) return false;
    const schemeSel =
      (fv?.selectedSchemeName || "").trim() ||
      selectedOptionData?.Scheme ||
      "";
    return schemeSel === "ALL";
  };

  const showRestrictedAllSchemeMessage = () => {
    setMessage(PAYOUT_ALL_SCHEME_NOT_ALLOWED_MESSAGE);
    dispatch(fetchShowAlertPayout(props.component));
    setTimeout(() => {
      dispatch(hideAlertPayout());
      setMessage(null);
    }, 8000);
  };
  const [loading, setLoading] = useState({ category: "", loading: false });
  const PreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const pvRun = PreviousValue(shouldRun);

  useEffect(() => {
    dispatch(setPayoutDashboard());
    return () => {
      dispatch(unsetPayoutDashboard());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetPayoutDashboardState());
  }, [props.component, dispatch]);

  // let sorted = [];

  // Array.prototype.sortBy = function (p) {
  //     return this.slice(0).sort(function (a, b) {
  //         return (a[p] > b[p]) ? 1 : (a[p] < b[p]) ? -1 : 0;
  //     });
  // }
  //sorted = getAllAPI && getAllAPI.devicePayoutObj && getAllAPI.devicePayoutObj[0] && getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos && getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos.sortBy("tileId");
  useEffect(() => {
    const controller = new AbortController();
    const fetchData = async () => {
      // if (getURLs[props.component].moduleName !== "Device Payout") {
      //   await Promise.all([
      //     dispatch(triggerFetchPayoutQuantity(obj, controller.signal)),
      //     dispatch(triggerFetchPayoutHeader(obj, controller.signal)),
      //   ]);
      // } else {
      dispatch(triggerFetchPayoutQuantity(obj, controller.signal));
      // }
    };

    const hideHeader = () => {
      return dispatch(triggerShowHeader(true));
    };

    function fetchTimeStamp() {
      return dispatch(
        triggerFetchTimeStamp(timeStampObj, getURLs[props.component].moduleName)
      );
    }

    //getAllAPI && getAllAPI.data && getAllAPI.data.content && getAllAPI.data.content[0] &&
    if (
      quantityObj &&
      quantityObj.tileData &&
      quantityObj.tileData[getURLs[props.component].urlQuantity] === undefined
    ) {
      if (shouldRun && getAllAPI?.data?.content?.[0]) {
        fetchData();
        fetchTimeStamp();
      }
    }
    if (!isBusinessType.businessType && pV && shouldRun) {
      if (
        filterValue.selectedSchemeName !== pV.selectedSchemeName ||
        filterValue.selectedSchemeType !== pV.selectedSchemeType ||
        filterValue.selectedDistributor !== pV.selectedDistributor ||
        filterValue.selectedRetailer !== pV.selectedRetailer
      ) {
        fetchData();
      }
    }
    hideHeader();

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllAPI, shouldRun, props.component]);

  const getURLs = {
    device: {
      urlQuantity:
        getAllAPI &&
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[0].tileEndPointUrl,
      urlHeaderCSV:
        getAllAPI &&
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[1].csvEndPointUrl,
      urlItemCSV:
        getAllAPI &&
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[0].csvEndPointUrl,
      moduleName: "Device Payout",
      csv1: "Line Item Level Details",
      csv2: "Pay out Details",
      isSectionActive:
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "device payout"
        )[0]?.modSecMasterTxDtos[0]?.isSectionActive,
      isModuleActive:
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "device payout"
        )[0].isModuleActive,
      isQtyCsvActive:
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[0].isCsvActive,
      isPayoutCsvActive:
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[1].isCsvActive,
      isQtyTileActive:
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[0].isTileActive,
      isPayoutTileActive:
        getAllAPI.devicePayoutObj &&
        getAllAPI.devicePayoutObj[0] &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.devicePayoutObj[0].secTilesMasterTxDtos[1].isTileActive,
    },
    activation: {
      urlQuantity:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[0]
          .tileEndPointUrl,
      urlHeader:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[1]
          .tileEndPointUrl,
      urlHeaderCSV:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[1].csvEndPointUrl,
      urlItemCSV:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[0].csvEndPointUrl,
      moduleName: "Activation Payout",
      csv1: "Activation Number Details",
      csv2: "Pay out Details",
      showDownloadButtons: true,
      isModuleActive:
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "activation payout"
        )[0].isModuleActive,
      isSectionActive:
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "activation payout"
        )[0]?.modSecMasterTxDtos[0]?.isSectionActive,
      isQtyCsvActive:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[0].isCsvActive,
      isPayoutCsvActive:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[1].isCsvActive,
      isQtyTileActive:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[0].isTileActive,
      isPayoutTileActive:
        getAllAPI &&
        getAllAPI.activationPayoutObj &&
        getAllAPI.activationPayoutObj[0] &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.activationPayoutObj[0].secTilesMasterTxDtos[1].isTileActive,
    },
    recharge: {
      urlQuantity:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[0].tileEndPointUrl,
      urlHeader:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[1].tileEndPointUrl,
      urlItemCSV:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[0].csvEndPointUrl,
      urlHeaderCSV:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[1].csvEndPointUrl,
      moduleName: "Recharge Payout",
      csv1: "Recharge Details",
      csv2: "Pay out Details",
      showDownloadButtons: true,
      isSectionActive:
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "recharge payout"
        )[0]?.modSecMasterTxDtos[0]?.isSectionActive,
      isModuleActive:
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "recharge payout"
        )[0].isModuleActive,
      isQtyCsvActive:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[0].isCsvActive,
      isPayoutCsvActive:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[1].isCsvActive,
      isQtyTileActive:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[0].isTileActive,
      isPayoutTileActive:
        getAllAPI &&
        getAllAPI.rechargePayoutObj &&
        getAllAPI.rechargePayoutObj[0] &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos &&
        getAllAPI.rechargePayoutObj[0].secTilesMasterTxDtos[1].isTileActive,
    },
  };
  let partnerIdentity = partnerIdentityForPayouts(
    filterValue.selectedPartnerRoleName
  );

  if (filterValue.selectedRetailer && filterValue.selectedRetailer !== "ALL") {
    partnerIdentity = "3";
  } else if (
    filterValue.selectedDistributor &&
    filterValue.selectedDistributor !== "ALL"
  ) {
    partnerIdentity = "2";
  }
  let FST = filterValue.selectedSchemeType;
  if (FST) {
    FST = filterSchemeType?.data?.content?.filter((val, index) => {
      return filterValue.selectedSchemeType === val.schemeTypeName;
    });
  }
  let timeStampObj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      moduleName: getURLs[props.component].moduleName,
      partnerRole: getPartnerRoleID(filterValue.selectedPartnerRoleName),
    },
  };
  let obj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      id:
        filterValue.selectedDistributor &&
        filterValue.selectedDistributor !== "ALL"
          ? filterValue.selectedDistributor.split(" - ")[1]
          : filterValue.orgId
          ? filterValue.orgId
          : filterValue.selectedRole.split(" - ")[2],
      fromDate: headerSelectedDateFrom, //"01-Jan-2019",
      toDate: headerSelectedDateTo, //"31-Dec-2020",
      partnerRoleType: filterValue.selectedPartnerRoleName, //"ZD",
      scheme:
        filterValue && filterValue.selectedSchemeName
          ? filterValue.selectedSchemeName === "ALL"
            ? ""
            : filterValue.selectedSchemeName.split("-")[1]
          : "",
      schemeNo:
        filterValue && filterValue.selectedSchemeName
          ? filterValue.selectedSchemeName === "ALL"
            ? ""
            : filterValue.selectedSchemeName.split("-")[2]
          : "",
      schemeType:
        filterValue && filterValue.selectedSchemeType
          ? filterValue.selectedSchemeType.schemeTypeName
          : "All",

      // FST && FST[0] && FST[0].schemeType ? FST[0].schemeType : 'All', //filterValue.selectedPartnerRoleName,//"ZD",
      section: "payout",
      moduleName: getURLs[props.component].moduleName,
      urlQuantity: getURLs[props.component].urlQuantity,
      urlHeader: getURLs[props.component].urlHeader,
      urlHeaderCSV: getURLs[props.component].urlHeaderCSV,
      urlItemCSV: getURLs[props.component].urlItemCSV,
      partnerIdentity: partnerIdentity, //need to change( dev pending ),
      jprTypeName: "", //need to change( dev pending ),
    },
  };

  const pV = PreviousValue(filterValue);

  const sendAudit = (viewName) => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: props.dashboardName,
        empId: filterValue?.agentId?.length
          ? filterValue?.agentId
          : filterValue?.orgId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: viewName,
      },
    };
    triggerDashboardAudit(obj);
  };

  function fetchCsv(option) {
    if (shouldBlockRestrictedAllDownload()) {
      showRestrictedAllSchemeMessage();
      return;
    }

    sendAudit(option === "csv1" ? "Quantity" : "Payout");

    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename:
        option === "csv1"
          ? `${filterValue?.selectedPartnerRoleName ?? ""}LineItemDetails`
          : `${filterValue?.selectedPartnerRoleName ?? ""}HeaderItemDetails`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    let csvExporter = new ExportToCsv(options);
    let filteredCsv;
    const controller = new AbortController();
    const syncPayoutCsvExport =
      props.component === "activation" || props.component === "recharge";
    if (checkPayoutCsv(headerSelectedDateFrom, headerSelectedDateTo)) {
      if (option === "csv1") {
        return dispatch(
          triggerFetchPayoutItemCSV(
            obj,
            "json",
            (response, params) => {
              if (syncPayoutCsvExport) {
                const exportPayload = response?.content;
                if (
                  exportPayload?.csvHeading &&
                  downloadPayoutCsvExportContent(
                    exportPayload,
                    `${filterValue?.selectedPartnerRoleName ?? ""}LineItemDetails`
                  )
                ) {
                  return;
                }
                dispatch(fetchShowAlertPayout(props.component));
                setTimeout(() => {
                  dispatch(hideAlertPayout());
                }, 5000);
                return;
              }
              if (response.content.length) {
                filteredCsv = payoutLineItemCsvFilter(
                  "lineItem",
                  filterValue.selectedPartnerRoleName,
                  getURLs[props.component].moduleName,
                  response.content
                );
                csvExporter.generateCsv(filteredCsv);
              } else {
                dispatch(fetchShowAlertPayout(props.component));
                setTimeout(() => {
                  dispatch(hideAlertPayout());
                }, 5000);
              }
            },
            (error, params) => {
              dispatch(showError());
              dispatch(fetchShowAlertPayout(props.component));
              setTimeout(() => {
                dispatch(hideAlertPayout());
                dispatch(hideError());
              }, 5000);
            },
            controller.signal
          )
        );
      } else {
        return dispatch(
          triggerFetchPayoutHeaderCSV(
            obj,
            (response, params) => {
              if (syncPayoutCsvExport) {
                const exportPayload = response?.content;
                if (
                  exportPayload?.csvHeading &&
                  downloadPayoutCsvExportContent(
                    exportPayload,
                    `${filterValue?.selectedPartnerRoleName ?? ""}HeaderItemDetails`
                  )
                ) {
                  return;
                }
                dispatch(fetchShowAlertPayout(props.component));
                setTimeout(() => {
                  dispatch(hideAlertPayout());
                }, 5000);
                return;
              }
              if (response.content.length) {
                filteredCsv = payoutLineItemCsvFilter(
                  "header",
                  filterValue.selectedPartnerRoleName,
                  getURLs[props.component].moduleName,
                  response.content
                );
                csvExporter.generateCsv(filteredCsv);
              } else {
                dispatch(fetchShowAlertPayout(props.component));
                setTimeout(() => {
                  dispatch(hideAlertPayout());
                }, 5000);
              }
            },
            (error, params) => {
              // console.log(error)
              dispatch(showError());
              dispatch(fetchShowAlertPayout(props.component));
              setTimeout(() => {
                dispatch(hideAlertPayout());
                dispatch(hideError());
              }, 5000);
            },
            controller.signal
          )
        );
      }
    } else {
      alert("date range should not be more than 7 days");
    }
  }

  const url = getURLs[props.component].urlQuantity;
  const urlHeader = getURLs[props.component].urlHeader;
  let qty =
    quantityObj &&
    quantityObj.qtyData &&
    quantityObj.qtyData[url] &&
    quantityObj.qtyData[url][0];
  let data =
    quantityObj &&
    quantityObj.tileData &&
    quantityObj.tileData[url] &&
    quantityObj.tileData[url][0];
  let hdrData =
    headerObj &&
    headerObj.tileData &&
    headerObj.tileData[urlHeader] &&
    headerObj.tileData[urlHeader][0];

  // if (getURLs[props.component].moduleName !== "Device Payout") {
  //   data = hdrData;
  // }

  // console.log(data, hdrData, qty, quantityObj, headerObj);

  const handleDownloadHeader = (category, filterValue) => {
    if (shouldBlockRestrictedAllDownload(filterValue)) {
      showRestrictedAllSchemeMessage();
      return;
    }

    setLoading({ category: category, loading: true });
    const [, schemeName, schemeNumber] =
      filterValue?.selectedSchemeName?.split("-");
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url:
          getURLs[props.component].moduleName === "Recharge Payout"
            ? "/fetch-rech-payout-annexure"
            : "/fetch-act-payout-annexure",
      },
      type: "POST",
      params: {
        dashboardName: getURLs[props.component].moduleName,
        category: category,
        schemeName: schemeName ?? "",
        schemeNumber: schemeNumber ?? "",
      },
      callback: (res) => {
        setLoading({ category: category, loading: false });
        const schemeNamePart = schemeName || "All";
        const schemeNumberPart = schemeNumber || "All";
        const dashboardNamePart =
          props.dashboardName?.replace(/\s+/g, "_") ?? "";
        const categoryPart = category?.replace(/\s+/g, "_") ?? "";
        const fileName = `${dashboardNamePart}_${
          filterValue?.selectedPartnerRoleName ?? ""
        }_${schemeNamePart}_${schemeNumberPart}_${categoryPart}`;
        downloadArrayAsCSV(res?.content, fileName);
      },
      errCallback: (err) => {
        setLoading({ category: category, loading: false });
        dispatch(showError());
        dispatch(fetchShowAlertPayout(props.component));
        setTimeout(() => {
          dispatch(hideAlertPayout());
        }, 5000);
      },
    };
    dispatch(triggerDownloadFile(obj));
  };

  return (
    <>
      <div className="container-fluid">
        <DashboardFilter
          component="payout"
          subComponent={props.component}
          dashboard={props.dashboardName}
        />
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h2
            className="pagetitle wow fadeInUp mb-0"
            data-wow-delay=".5s"
            data-wow-duration="0.7s"
          >
            {getURLs[props.component].moduleName}
          </h2>
          {getURLs[props.component].showDownloadButtons && (
            <div
              className="wow fadeInUp"
              data-wow-delay=".5s"
              data-wow-duration="0.7s"
            >
              <div className="dropdown">
                <button
                  className="btn btn-primary dropdown-toggle d-flex align-items-center"
                  type="button"
                  id="downloadAnnexureDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FileDownloadOutlinedIcon />
                  <span className="d-none d-md-inline me-4">
                    Download Annexure
                  </span>
                </button>

                <ul className="dropdown-menu" style={{ minWidth: "200px" }}>
                  {["Header", "Line Item"].map((category) => {
                    const isLoading =
                      loading.loading && loading.category === category;

                    return (
                      <li key={category}>
                        <button
                          className="dropdown-item d-flex align-items-center gap-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownloadHeader(category, filterValue);
                          }}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <CircularProgress size={18} />
                          ) : (
                            <FileDownloadOutlinedIcon />
                          )}
                          {category} Annexure
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}

          {/* {getURLs[props.component].moduleName !== "Device Payout" ? (
            <button
              type="button"
              className="btn btn-primary text-white mt-3 mb-3 wow fadeInUp"
              data-wow-delay=".5s"
              data-wow-duration="0.7s"
              onClick={() => {
                setShowModal(true);
              }}
            >
              My Downloads
            </button>
          ) : null} */}
        </div>
        {showAlert === props.component ? (
          <Alert
            showAlert={showAlert}
            showError={error}
            //message={message}
            hideAlert={() => dispatch(hideAlertPayout())}
          />
        ) : null}
        {/* {getAllAPI?.loading ? (
          <Spinner />
        ) : } */}

        {getAllAPI?.loading ? (
          <Spinner />
        ) : getURLs &&
          getURLs[props.component]?.isModuleActive === "Y" &&
          getURLs[props.component]?.isSectionActive === "Y" ? (
          getAllAPI?.data?.content?.[0] ? (
            quantityObj.loading ? (
              <Spinner />
            ) : !(typeof qty === "undefined" && typeof data === "undefined") ? (
              <div
                className="whitebox wow fadeInUp"
                data-wow-delay=".6s"
                data-wow-duration="0.7s"
                data-cy="payout-section"
              >
                <div className="tabcontbox">
                  <div className="row">
                    <div className="col-md-3" data-cy="quantity">
                      {getURLs?.[props.component]?.isQtyTileActive === "Y" ? (
                        !quantityObj.loading ? (
                          typeof qty !== "undefined" ? (
                            <div className="roundborder actc">
                              <div className="mdnsubtitle pb-4 pt-1">
                                <div className="leftdiv text-payout">
                                  Quantity
                                </div>
                                <div
                                  style={{
                                    float: "right",
                                    fontSize: "15px",
                                    color: "gray",
                                    // paddingRight: "30px",
                                    padding: "3px 0px 0px 18px",
                                  }}
                                >
                                  {getURLs[props.component]?.isQtyCsvActive ===
                                  "Y" ? (
                                    lineItemCsvLoading.loading ? (
                                      <Spinner showAlert={false} />
                                    ) : (
                                      <span
                                        className="downloadarrow"
                                        data-cy="csv-download"
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-link btn-sm m-0 p-0"
                                          onClick={() => fetchCsv("csv1")}
                                        >
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/assets/images/icons/download-arrow.svg"
                                            }
                                            alt="download"
                                          />
                                        </button>
                                      </span>
                                    )
                                  ) : null}
                                </div>
                              </div>
                              <CustomCardPayout
                                value={qty ?? 0}
                                label="QTY"
                                color="payoutgrad1"
                                paddingTop="pt-1"
                              />
                              <div
                                className="card-timestamp border-top mt-3"
                                data-cy="timestamp"
                              >
                                <i className="fa fa-history mr-2 mt-2 mb-0"></i>
                                Updated on{" "}
                                {timeStampFormat(
                                  timestamp?.data?.[
                                    getURLs[props.component]?.moduleName
                                  ]?.[
                                    getURLs[props.component]?.moduleName
                                  ]?.[0]?.tileTimestamp?.split(".")[0]
                                )}
                              </div>
                            </div>
                          ) : (
                            <Error error={quantityObj.error} />
                          )
                        ) : (
                          <Spinner />
                        )
                      ) : null}
                    </div>
                    <div className="col-md-9" data-cy="payout">
                      {getURLs?.[props.component]?.isPayoutTileActive ===
                      "Y" ? (
                        !headerObj.loading ? (
                          typeof data !== "undefined" ? (
                            <div className="roundborder actc">
                              <div className="mdnsubtitle pb-3">
                                <div className="leftdiv text-payout">
                                  Payout
                                </div>
                                <div
                                  style={{
                                    float: "right",
                                    fontSize: "15px",
                                    color: "gray",
                                    padding: "3px 0px 0px 18px",
                                    height: 15,
                                  }}
                                >
                                  {getURLs &&
                                  getURLs[props.component]
                                    ?.isPayoutCsvActive === "Y" ? (
                                    headerCsvLoading &&
                                    headerCsvLoading?.loading ? (
                                      <Spinner showAlert={false} />
                                    ) : (
                                      <span
                                        className="downloadarrow"
                                        data-cy="csv-download"
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-link btn-sm m-0 p-0"
                                          onClick={() => fetchCsv("csv2")}
                                        >
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/assets/images/icons/download-arrow.svg"
                                            }
                                            alt="download"
                                          />
                                        </button>
                                      </span>
                                    )
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                {data &&
                                  data.map((item, index) => (
                                    <CustomCardPayout
                                      value={item.tileValue ?? 0}
                                      label={formatTileName(item.tileName)}
                                      color={`payoutgrad${index + 2}`}
                                      key={index}
                                    />
                                  ))}
                              </div>

                              <div
                                className="card-timestamp border-top mt-2"
                                data-cy="timestamp"
                              >
                                <i className="fa fa-history mr-2 mt-2 mb-0"></i>
                                Updated on{" "}
                                {timeStampFormat(
                                  timestamp?.data?.[
                                    getURLs[props.component]?.moduleName
                                  ]?.[
                                    getURLs[props.component]?.moduleName
                                  ]?.[1]?.tileTimestamp?.split(".")[0]
                                )}
                              </div>
                            </div>
                          ) : (
                            <Error error={headerObj.error} />
                          )
                        ) : (
                          <Spinner />
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : quantityObj.error ? (
              <div
                className="whitebox wow fadeInUp text-center"
                data-wow-delay=".6s"
                data-wow-duration="0.7s"
              >
                Unable to fetch data
              </div>
            ) : getAllAPI?.error ? (
              <div
                className="whitebox wow fadeInUp text-center"
                data-wow-delay=".6s"
                data-wow-duration="0.7s"
              >
                Unable to fetch data
              </div>
            ) : (
              <div
                className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
                data-wow-delay=".6s"
                data-wow-duration="0.7s"
              >
                <ul>
                  <li>{window.CLICK_RUN_1}</li>
                  <li>{window.CLICK_RUN_2}</li>
                </ul>
              </div>
            )
          ) : null
        ) : null}
      </div>
      {/* {showModal && (
        <DownloadModal
          showModal={showModal}
          setShowModal={setShowModal}
          moduleName={getURLs[props.component].moduleName}
        />
      )} */}
    </>
  );
};

export default PayoutDashboard;
